import { render, staticRenderFns } from "./GiftCard.vue?vue&type=template&id=a4ddade6&"
import script from "./GiftCard.vue?vue&type=script&lang=ts&"
export * from "./GiftCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports